import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Sidebar_List.css"; // ← new or updated CSS file

const Sidebar_List = (props) => {
  const location = useLocation();
  const [activeKey, setActiveKey] = useState(null);

  const routes = [
    { key: "0", path: "/my-account", label: "My Account" },
    { key: "1", path: "/trade", label: "Trade" },
    { key: "2", path: "/deposit", label: "Deposit" },
    { key: "3", path: "/withdrawal", label: "Withdrawal" },
    { key: "4", path: "/transaction-history", label: "Transaction History" },
    { key: "5", path: "/performance", label: "Performance" },
    { key: "6", path: "/settings", label: "Settings" },
    { key: "7", path: "/refer-and-earn", label: "Refer & Earn" },
    { key: "8", path: "/market-news", label: "Help Centre" },
  ];

  useEffect(() => {
    const current = routes.find((route) => route.path === location.pathname);
    if (current) {
      setActiveKey(current.key);
    } else {
      setActiveKey(null);
    }
  }, [location.pathname]);

  return (
    <div className="sidebar-list-container">
      <ul className="sidebar-list">
        {routes.map((route) => (
          <li key={route.key} className="sidebar-item-wrapper">
            <Link
              to={route.path}
              className={`sidebar-item ${activeKey === route.key ? "active" : ""}`}
              onClick={props.handleClose}
            >
              <span className="sidebar-label">{route.label}</span>
            </Link>
          </li>
        ))}

        {/* Notification Item */}
        {/* <li className="sidebar-item-wrapper notification-item">
          <button
            className="sidebar-item notification-btn"
            onClick={() => {
              props.onNotificationClick();
              props.handleClose?.();
            }}
          >
            <span className="sidebar-label">Notifications</span>
          </button>
        </li> */}
      </ul>
    </div>
  );
};

export default Sidebar_List;